export default __webpack_public_path__ + "static/media/rozcestnik-pk-bg.0c7e2687.png";